import { Address } from '../shared';

export function address2Array(obj: Address): string[] {
    const addressArray = [];

    if (obj.addressLine1) {
        addressArray.push(obj.addressLine1);
    }
    if (obj.addressLine2) {
        addressArray.push(obj.addressLine2);
    }
    if (obj.addressLine2) {
        addressArray.push(obj.addressLine2);
    }
    let city = '';
    if (obj.country === 'US') {
        if (obj.city) {
            // eslint-disable-next-line prefer-destructuring
            city = obj.city;
            if (obj.state) {
                city += ', ';
            }
        }
        if (obj.state) {
            city += obj.state;
            if (obj.postalCode) {
                city += ' ';
            }
        }

        if (obj.postalCode) {
            city += obj.postalCode;
        }
    } else if (obj.country) {
        if (obj.city) {
            city = obj.city + ', ';
        }
        city += obj.country;
    }

    if (city && city.length > 0) {
        addressArray.push(city);
    }

    return addressArray;
}
